module.exports = __webpack_public_path__ + "img/file.db5e5db7.png";